import Vuex from "vuex";
import Vue from "vue";
import globals from "../../configs/globals";

Vue.use(Vuex);

import navbarStore from "./store-navbar";
import tabStore from "./store-tabs";
import toolbarStore from "./store-toolbar";
import appStore from "./store-app";

const store = new Vuex.Store({
    modules: {
        app: appStore,
        navbar: navbarStore,
        tabs: tabStore,
        toolbar: toolbarStore,
    },
    state: {
        localSettings: {},
        language: globals.language,
        currency: "HUF",
        dentalStates: {},
        history: [],
        tutorials: [],
        networkStatus: "online",
        cache: {},
        isPro: false,
    },

    getters: {
        localSettings: function(state, getters) {
            return (function(key) {
                if (typeof(store.state.localSettings)!=="object") return null;
                if (typeof(store.state.localSettings[key])==="undefined") return null;
                return store.state.localSettings[key];
            });
        },
    },

    mutations: {
        pushToHistory: function(state, data) {
            state.history.unshift(data);
        },

        storeHistory: function(state) {
            localStorage.setItem("history", JSON.stringify(state.history));
        },

        loadDataFromLocalStorage: function(state) {
            if (window.localStorage) {
                // eslint-disable-next-line camelcase
                const LS_History = localStorage.getItem("history");
                // eslint-disable-next-line camelcase
                if (LS_History) state.history = JSON.parse(LS_History);
            }
        },

        setLanguage: function(state, language) {
            state.language = language;
        },

        setCurrency: function(state, currency) {
            state.currency = currency;
        },
    },
});

export default store;
